export const ID_DIVIDER = '|==WinWinTravel==|'
